// Product Action Types
export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';

export const FETCH_PRODUCT_DETAIL_REQUEST = 'FETCH_PRODUCT_DETAIL_REQUEST';
export const FETCH_PRODUCT_DETAIL_SUCCESS = 'FETCH_PRODUCT_DETAIL_SUCCESS';
export const FETCH_PRODUCT_DETAIL_FAILURE = 'FETCH_PRODUCT_DETAIL_FAILURE';

export const ADD_PRODUCT_REQUEST = 'ADD_PRODUCT_REQUEST';
export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS';
export const ADD_PRODUCT_FAILURE = 'ADD_PRODUCT_FAILURE';

export const UPDATE_PRODUCT_REQUEST = 'UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';

export const DELETE_PRODUCT_REQUEST = 'DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE = 'DELETE_PRODUCT_FAILURE';

export const SEARCH_PRODUCTS_REQUEST = 'SEARCH_PRODUCTS_REQUEST';
export const SEARCH_PRODUCTS_SUCCESS = 'SEARCH_PRODUCTS_SUCCESS';
export const SEARCH_PRODUCTS_FAILURE = 'SEARCH_PRODUCTS_FAILURE';

export const FETCH_ACTIVE_PRODUCTS_REQUEST = 'FETCH_ACTIVE_PRODUCTS_REQUEST';
export const FETCH_ACTIVE_PRODUCTS_SUCCESS = 'FETCH_ACTIVE_PRODUCTS_SUCCESS';
export const FETCH_ACTIVE_PRODUCTS_FAILURE = 'FETCH_ACTIVE_PRODUCTS_FAILURE';

export const TOGGLE_PRODUCT_ACTIVE_REQUEST = 'TOGGLE_PRODUCT_ACTIVE_REQUEST';
export const TOGGLE_PRODUCT_ACTIVE_SUCCESS = 'TOGGLE_PRODUCT_ACTIVE_SUCCESS';
export const TOGGLE_PRODUCT_ACTIVE_FAILURE = 'TOGGLE_PRODUCT_ACTIVE_FAILURE';

export const FETCH_PRODUCT_STATS_REQUEST = 'FETCH_PRODUCT_STATS_REQUEST';
export const FETCH_PRODUCT_STATS_SUCCESS = 'FETCH_PRODUCT_STATS_SUCCESS';
export const FETCH_PRODUCT_STATS_FAILURE = 'FETCH_PRODUCT_STATS_FAILURE';
